import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
import { isPage } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from "top-validation";

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();

  const btn = document.querySelector('.c-hamburger');
  const gnav = document.querySelector('.nav-block');
  const header = document.querySelector('.header');
  const navLinks = document.querySelectorAll('.header .nav-lists li a'); // リンクを全て選択

  // ハンバーガーメニューのトグル
  if (btn && gnav) {
    btn.addEventListener('click', () => {
      gnav.classList.toggle('is-active');
      btn.classList.toggle('is-open');
      header.classList.toggle('is-fixed');
    });
  }

  // リンククリック時にハンバーガーメニューを閉じる
  if (navLinks.length > 0) {
    navLinks.forEach(link => {
      link.addEventListener('click', () => {
        gnav.classList.remove('is-active');
        btn.classList.remove('is-open');
        header.classList.remove('is-fixed');
      });
    });
  }
});
if (isPage('home')) {
  var mv = document.querySelector('.front-style_art');
  window.addEventListener('scroll', function() {
    var scrollY = window.scrollY;
    // .front-style_art の固定処理
    if (mv) {
      var frontServiceArtElements = document.querySelectorAll('.front-style_art');
      frontServiceArtElements.forEach(function(frontServiceArt) {
        var elementTop = frontServiceArt.offsetTop;
        var elementBottom = elementTop + frontServiceArt.offsetHeight;
        var removeClassPoint = elementBottom - 350;

        if (scrollY >= elementTop && scrollY < removeClassPoint) {
          mv.classList.add('is-fixed');
        } else {
          mv.classList.remove('is-fixed');
        }
      });
    }
  });

  var mySwiperElement = document.querySelector('.front-report_art');
  const gallery = document.querySelector('.front-report_lists');
  const slideElements = gallery.querySelectorAll('.swiper-slide');
  const slideCount = slideElements.length;
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const stopSlideCount = isMobile ? 1 : 2;

  if(slideCount <= stopSlideCount) {
    gallery.classList.add('centered-gallery'); // 中央寄せ用クラス追加
  } else {
      var mySwiper = new Swiper(mySwiperElement, {
        loop: true,
        loopAdditionalSlides: 2,
        loopedSlides: 3,
        speed: 2000,
        centeredSlides: true,
        slidesPerView: '1.5',
        spaceBetween: 20, 
        allowTouchMove: true,
        pagination: {
          el: '.swiper-pagination', // ページネーション要素のクラス
          clickable: true, // クリックによるスライド切り替えを有効にする
          type: 'bullets', // 'bullets'（デフォルト） | 'fraction' | 'progressbar'
        },
        autoplay: {
          delay: 1000,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 50,
          },
        }
      });
    } 
}


// .mv共通
document.addEventListener('DOMContentLoaded', function() {
  var mvElements = document.querySelectorAll('.mv');
  var header = document.querySelector('.header');

  window.addEventListener('scroll', function() {
    var scrollY = window.scrollY;

    // .mv の固定処理
    if (mvElements.length > 0) {
      mvElements.forEach(function(mv) {
        var elementTop = mv.offsetTop;
        var elementBottom = elementTop + mv.offsetHeight;
        var removeClassPoint = elementBottom - 350;

        if (scrollY >= elementTop && scrollY < removeClassPoint) {
          mv.classList.add('is-fixed');
        } else {
          mv.classList.remove('is-fixed');
        }

        // mv が画面に入ったときにクラスを取り除く処理
        var mvRect = mv.getBoundingClientRect();
        var isMvVisible = mvRect.top < window.innerHeight && mvRect.bottom > 0;

        if (isMvVisible) {
          mv.classList.remove('is-fixed');
        }
      });
    }

    // .header の固定処理
    if (header) {
      var isAnyMvVisible = Array.from(mvElements).some(function(mv) {
        var mvRect = mv.getBoundingClientRect();
        return mvRect.bottom > 0 && mvRect.top < window.innerHeight;
      });

      // mv が画面に入ったら header の固定クラスを取り除く
      if (isAnyMvVisible) {
        header.classList.remove('fixed-position');
      } else {
        if (scrollY > 50) {
          header.classList.add('fixed-position');
        } else {
          header.classList.remove('fixed-position');
        }
      }
    }
  });
});


if (isPage('contact', 'request')) {
  document.addEventListener('DOMContentLoaded', function() {
    const topValidationInstance  = topValidation();

    if (isPage('contact')) {
      //定義
      const consultationMethod = document.querySelector('input[name="radio01"][value="無料相談"]');
      const otherRequest = document.querySelector('input[name="radio01"][value="その他のお問い合わせ"]');
      const formInputWrap = document.querySelector('.form-input_wrap');
      const contactLabel = document.querySelector('.form-input_row.is-content .contact-label');
      const date = document.querySelector('#select-date-area').querySelector('#date');
      const time = document.querySelector('#select-time-area').querySelector('#time');
      // 初期状態を設定
      formInputWrap.style.display = 'none';

      const preview = document.querySelector('.mw_wp_form_preview');
      if(preview !== null && consultationMethod) {
        formInputWrap.style.display = 'flex';
        contactLabel.innerHTML = '<span class="attached-text">必須</span>相談したい内容';
      }

      // バリデーションクラスを追加する関数
      function addValidationClasses() {
        // formInputs.forEach(input => input.classList.add('check_real-time'));
        if(!date.classList.contains('check_required')) {
          date.classList.add('check_required');
        }
        if(!time.classList.contains('check_required')) {
          time.classList.add('check_required');
        }
      }
      // バリデーションクラスを削除する関数
      function removeValidationClasses() {
        if(date.classList.contains('check_required')) {
          date.classList.remove('check_required');
        }
        if(time.classList.contains('check_required')) {
          time.classList.remove('check_required');
        }
      }
      // ラジオボタンの状態をチェックする関数
      function updateFormVisibility() {
        if (consultationMethod && consultationMethod.checked) {
            if (formInputWrap) {
              formInputWrap.style.display = 'flex';
            }
            if (contactLabel) {
              contactLabel.innerHTML = '<span class="attached-text">必須</span>相談したい内容';
            }
            addValidationClasses(); // リアルタイムバリデーションクラスを追加
            topValidationInstance.refresh();
        };
        if (otherRequest && otherRequest.checked) {
            if (formInputWrap) {
              formInputWrap.style.display = 'none';
            }
            if (contactLabel) {
              contactLabel.innerHTML = '<span class="attached-text">必須</span>お問い合わせ内容';
            }
            removeValidationClasses(); // リアルタイムバリデーションクラスを削除
            topValidationInstance.refresh();
        }
      }

      // ラジオボタンの変化を監視
      if (consultationMethod) {
        consultationMethod.addEventListener('change', updateFormVisibility);
      }
      if (otherRequest) {
        otherRequest.addEventListener('change', updateFormVisibility);
      }

      // ページ読み込み時にラジオボタンの状態を反映
      updateFormVisibility();

      initFlatpickr();
    }
  });
}


/*-------------------------------------------------------------------------------
  gsap
--------------------------------------------------------------------------------*/
gsap.registerPlugin(ScrollTrigger);

if (document.querySelector('.is-fadein')) {
  gsap.utils.toArray('.is-fadein').forEach((item, index) => {
    gsap.set(item, {
      y: 100,
      opacity: 0,
      filter: 'blur(15px)',
    });

    gsap.to(item, {
      opacity: 1,
      y: 0,
      filter: 'blur(0px)',
      duration: 1,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: item,
        start: 'top 80%',
        once: true,
      },
    });
  });
}
if (document.querySelector('.is-fadein')) {
  gsap.utils.toArray('.is-fade-static').forEach((item) => {
    gsap.set(item, {
      opacity: 0,
      filter: 'blur(15px)',
      scale: 0.8,
    });

    gsap.to(item, {
      opacity: 1,
      filter: 'blur(0px)',
      scale: 1,
      duration: 1.2,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: item,
        start: 'top 80%',
        once: true,
      },
    });
  });
}

if (document.querySelector('.is-fadein_img')) {
  gsap.utils.toArray('.is-fadein_img').forEach((item, index) => {
    gsap.set(item, {
      y: 50,
      opacity: 0,
      filter: 'blur(15px)',
    });

    gsap.to(item, {
      opacity: 1,
      y: 0,
      filter: 'blur(0px)',
      duration: 1,
      delay: 0.3,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: item,
        start: 'top 80%',
        once: true,
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.fade-list')) {
    gsap.utils.toArray('.fade-list').forEach((item) => {
      const originalTransform = item.style.transform;
      const randomDelay = Math.random() * 0.5 + 0.1; // delayを早める

      gsap.fromTo(item,
        {
          opacity: 0,
          scale: 0.9,
          y: 20,
        },
        {
          opacity: 1,
          scale: 1,
          y: 0,
          duration: 1.5,
          delay: randomDelay,
          ease: 'slow(0.7, 0.7, false)',
          scrollTrigger: {
            trigger: item,
            start: 'top 90%', // トリガーポイントを早める
            once: true,
          },
          onUpdate: function() {
            item.style.transform = originalTransform;
          }
        }
      );
    });
  }

  gsap.registerPlugin(ScrollTrigger);
  gsap.to('.front-plan_art:before', {
    yPercent: 50, // スクロール時に背景画像をどれだけ移動させるかを指定
    ease: "none", // 緩急をつけない動き
    scrollTrigger: {
      trigger: '.front-plan_art', // パララックス効果を適用する要素
      start: 'top bottom', // 要素が画面に入るタイミング
      end: 'bottom top',   // 要素が画面から出るタイミング
      scrub: true,         // スクロールに合わせてアニメーションを動かす
      markers: false       // 開発時にマーカーを表示する場合はtrue
    }
  });
});

async function initFlatpickr() {
  const dateInput = document.querySelector('input[name="date"]:not([type="hidden"]');
  const today = new Date();
  const threeMonthsFromNow = new Date();
  threeMonthsFromNow.setMonth(today.getMonth() + 3);
  const datesToExclude = await excludeDates();

  if (dateInput) {
    flatpickr(dateInput, {
      locale: 'ja',
      dateFormat: "Y年m月d日",
      minDate: "today",
      maxDate: threeMonthsFromNow,
      disable: datesToExclude,
      disableMobile: true
    });
  }
}

async function excludeDates() {
  const url = "https://www.rweddings.jp/wp-json/wp/v2/org_api";
  try {
    const response = await fetch(url);
    const data = await response.json();
    return data.map(item => item.holiday_date);
  } catch (error) {
    console.error("Error fetching holiday dates:", error);
    return [];
  }
}

// コンセプトのスライダー設定
document.addEventListener('DOMContentLoaded', function() {
  // ページの条件チェック
  if (isPage('home', 'concept')) {
      // スライダーの初期化処理
      function initializeSliders() {
          let sliders = document.querySelectorAll(".layout_img_list_wrapper li");
          sliders.forEach(function(sliderItem) {
              const slideCount = sliderItem.querySelectorAll(".swiper-slide").length;

              // サムネイルスライダーの設定
              const sliderThumbnail = new Swiper("#thumbs", {
                  slideToClickedSlide: true,
                  slidesPerView: 3,
                  spaceBetween: 10,
                  breakpoints: {
                      768: {
                          slidesPerView: 4,
                          spaceBetween: 20,
                      },
                  },
              });

              // メインスライダーの設定
              const slider = new Swiper("#slider", {
                  slidesPerView: 1,
                  loop: false,
                  loopedSlides: slideCount,
                  disableOnInteraction: true,
                  navigation: {
                      nextEl: ".swiper-next",
                      prevEl: ".swiper-prev",
                  },
                  thumbs: {
                      swiper: sliderThumbnail,
                  },
              });
          });
      }
      // フェードアップアニメーションの初期化処理
      function initializeFadeUp() {
          const fadeUpItems = document.querySelectorAll('.fadeUp');
          fadeUpItems.forEach(fadeUpItem => {
              fadeUpItem.style.visibility = 'hidden'; // 初期状態の設定
              gsap.from(fadeUpItem, {
                  duration: 1,
                  autoAlpha: 0,
                  y: 50,
                  ease: "power3.easeOut",
                  scrollTrigger: {
                      trigger: fadeUpItem,
                      start: 'top 80%',
                      end: 'center center',
                      scrub: false,
                      once: true,
                  },
              });
          });
      }
      // スライダーとフェードアップアニメーションの初期化
      initializeSliders();
      initializeFadeUp();
  }
});

//ドリンク　ギャラリー1枚目はabsoluteにしている為投稿枚数により崩れてしまっていた為JSでクラスを付けております
document.addEventListener('DOMContentLoaded', function() {
  const imgGroups = document.querySelectorAll('.drinks-imgGroup');

  imgGroups.forEach(function(imgGroup) {
    const items = imgGroup.querySelectorAll('li');

    // リストのアイテムが1つまたは2つならクラス 'is-fewPosts' を追加
    if (items.length === 1 ) {
      imgGroup.classList.add('is-fewPosts');
      console.log('Class is-fewPosts added to a group with', items.length, 'items');
    } else {
      console.log('Group has', items.length, 'items');
    }
  });
});


/**
 * WP 画像ブロックにboxerを付与
 * @param {string} classname - add classname
 */
export function wpAddImageBoxer (classname = 'boxer') {
  const imageBlocks = document.querySelectorAll('.wp-block-image');
  imageBlocks.forEach(block => {
    const link = block.querySelector('a');
    if (link) {
      link.classList.add(classname);
    }
  });
}

/**
 * WP ギャラリーブロックにデータ属性を付与
 * @param {string} classname - add classname
 */
export function wpAddGallaryBoxer () {
  const galleries = document.querySelectorAll('.wp-block-gallery');

  galleries.forEach((gallery, index) => {
    const uniqueDataValue = `gallery-${index + 1}`;
    const imageBlocks = gallery.querySelectorAll('.wp-block-image');
    imageBlocks.forEach(block => {
      const link = block.querySelector('a');
      if (link) {
        link.setAttribute('data-gallery', uniqueDataValue);
      }
    });
  });
}


/**
 * 広告トラッキングパラメータ管理
 * sessionStorageを使用してgclid、fbclidを保持し、フォームのhiddenフィールドに自動セット
 * _gaはCookieから取得
 */
(function($) {
  'use strict';

  // --- 0. 保存対象のパラメータ一覧（追加されたUTMパラメータ含む） ---
  const trackingParams = [ 'gclid', 'fbclid', 'utm_source', 'utm_medium', 'utm_campaign' ];

  // --- 1. URLパラメータからsessionStorageに保存 ---
  function saveParamToSessionStorage(paramName) {
    const params = new URLSearchParams(window.location.search);
    const value = params.get(paramName);
    if (value) {
      sessionStorage.setItem(paramName, value);
      console.log(`${paramName} saved to sessionStorage:`, value);
    }
  }

  // --- 2. sessionStorageからhiddenフィールドにセット ---
  function setHiddenFromSessionStorage(paramName) {
    const value = sessionStorage.getItem(paramName);
    if (value) {
      // MW Formのフィールド名に対応（複数の命名規則に対応）
      const selectors = [
        `input[name="${paramName}"]`,
        `input[name="data[${paramName}]"]`,
        `input[name="mw_wp_form_${paramName}"]`,
        `input[data-name="${paramName}"]`
      ];
      
      selectors.forEach(selector => {
        const input = document.querySelector(selector);
        if (input) {
          input.value = value;
          console.log(`${paramName} set to hidden field:`, value);
        }
      });
    }
  }

  // --- 3. Cookieから値を取得 ---
  function getCookieValue(name) {
    const match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return match ? match.pop() : '';
  }

  // --- 4. _gaをCookieから取得してhiddenフィールドにセット ---
  function setGAFromCookie() {
    const gaValue = getCookieValue('_ga');
    if (gaValue) {
      // MW Formのフィールド名に対応（複数の命名規則に対応）
      const selectors = [
        'input[name="_ga"]',
        'input[name="data[_ga]"]',
        'input[name="mw_wp_form__ga"]',
        'input[data-name="_ga"]'
      ];
      
      selectors.forEach(selector => {
        const input = document.querySelector(selector);
        if (input) {
          input.value = gaValue;
          console.log('_ga set to hidden field:', gaValue);
        }
      });
    }
  }

  // --- 5. フォームが動的に読み込まれる場合に対応するMutationObserver ---
  function observeFormChanges() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // 新しく追加されたフォーム要素をチェック
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              const forms = node.querySelectorAll ? node.querySelectorAll('form') : [];
              if (forms.length > 0 || node.tagName === 'FORM') {
                // フォームが見つかったらhiddenフィールドを更新
                setTimeout(() => {
                  trackingParams.forEach(setHiddenFromSessionStorage);
                  setGAFromCookie();
                }, 100);
              }
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // --- 6. ページ読み込み時とDOMContentLoaded時の処理 ---
  function initAdTracking() {
    // URLパラメータをsessionStorageに保存
    trackingParams.forEach(saveParamToSessionStorage);

    // hiddenフィールドにセット（ページ読み込み時）
    setTimeout(() => {
      trackingParams.forEach(setHiddenFromSessionStorage);
      setGAFromCookie();
    }, 100);

    // フォームの動的変更を監視
    observeFormChanges();
  }

  // --- 7. 実行 ---
  // DOMContentLoadedで実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAdTracking);
  } else {
    initAdTracking();
  }

  // jQueryが利用可能な場合は$(document).ready()でも実行
  if (typeof $ !== 'undefined') {
    $(document).ready(function() {
      setTimeout(initAdTracking, 200);
    });
  }
})(jQuery);

// オフコンバージョン計測用パラメーターの削除
document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.mw_wp_form_complete')) {
    const params = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid', 'fbclid'];
    params.forEach(function (param) {
      sessionStorage.removeItem(param);
    });
    console.log('sessionStorage cleared');
  }
});
